import React from 'react';

import ContactList from './contact/ContactList';

export default function ContactPage() {
  return (
    <div className="flex flex-col gap-10 pb-20">
      <section className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8 pt-12 md:pt-16">
        <ContactList />
      </section>
    </div>
  );
}


